export default __webpack_public_path__ + "static/BrunaBPM-5e7ffcf21b4c6ab798a481af4b501b40.jpeg";